import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router
} from "@angular/router";
import { Observable } from "rxjs";
import { UserProfileService } from "app/core/services/user-profile/user-profile.service";
import { map, take } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class WelcomeGuard implements CanActivate {
  constructor(
    private userProfileService: UserProfileService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.userProfileService.currentUser.pipe(
      take(1),
      map((user: any) => {
        if (user && user.birthDate && user.data && user.data.address) {
          return true;
        } else {
          return this.router.createUrlTree(["/download"]);
        }
      })
    );
  }
}
